export default __webpack_public_path__ + "static/media/favicon.bf13f5bc.ico";